module.exports = __webpack_public_path__ + "img/lens-150-plus-03.7c9921e5.png";